<div fxLayout="row" class="page-footer">
  <span fxLayoutAlign="center center" [matMenuTriggerFor]="languageChoices" [matTooltip]="'LABEL_CHANGE_LANG' | translate">
      <a class="language-link">{{ selectedLanguage() }}</a>
  </span>

  <!-- languages sub-menu -->
  <mat-menu #languageChoices="matMenu">
    <button 
      mat-menu-item
      (click)="changeLanguage(language)" 
      *ngFor="let language of languages"
      >
      <span>{{ language?.name | translate}} ({{ language?.value }})</span>
    </button>
  </mat-menu>

  <div fxFlex fxFlexAlign="end">
    <mat-label class="mat-caption" [class.smaller-font]="media.isActive('lt-sm')">
      {{ webtoolVersion }}
      Privacy Policy
      | <a href="https://www.electronicscience.com/dpoqr.html" target="_blank">National Privacy Commission Seal</a>
      | © Electronic Science. All Rights Reserved
    </mat-label>
  </div>
</div>